import React, { useState } from "react";
import {
    Box,
    Button,
    FormControl,
    IconButton,
    MenuItem,
    Select,
    Typography,
    useTheme,
} from "@mui/material";
import { ArrowBack, Close } from "@mui/icons-material";
import { useTheme as useCustomTheme } from "../style/theme";
import CustomImportEmpty from "./CustomImportEmpty";
import * as XLSX from "xlsx";
import axios from "axios";
import { useMessage } from "./Header";

const ImportModal = ({ open,handleDone,selectedFile,setSelectedFile,handleClose }) => {
    const [mapDetails, setMapDetails] = useState(false);
    const { mode: themeMode } = useCustomTheme();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (
            file &&
            [
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "text/csv",
            ].includes(file.type)
        ) {
            setSelectedFile(file);
        } else {
            alert(
                "Invalid file type! Only xls, xlsx, and csv formats are supported."
            );
        }
    };

    return (
        <div>
            <CustomImportEmpty isScrollable={true} open={open} onClose={handleClose} handleMapDetails={handleDone}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 2,
                        borderBottom: "1px solid #ddd",
                        position: "sticky",
                        backgroundColor: themeMode == 'dark' ? '#171717' : "#fff",
                        top: 0,
                        zIndex: 10, // Keeps it above scrollable content
                    }}
                >
                    <div className="flex items-center">
                        <IconButton
                            sx={{
                                backgroundColor: themeMode == "light" ? "#edf0f4" : "#3333",
                                mr: 2,
                                fontSize: 14,
                                borderRadius: "6px",
                            }}
                            onClick={handleClose}
                        >
                            <ArrowBack fontSize="16px" />
                        </IconButton>
                        <Typography variant="h6">Import</Typography>
                    </div>
                    <IconButton
                        sx={{
                            backgroundColor: themeMode == "light" ? "#edf0f4" : "#3333",
                            fontSize: 16,
                            borderRadius: "6px",
                        }}
                        onClick={handleClose}
                    >
                        <Close fontSize="16px" />
                    </IconButton>
                </Box>

                {!mapDetails && (
                    <div className="p-5">
                        <Box sx={{ padding: 2 }} className={`${themeMode == 'dark' ? 'bg-[#171717]' : 'bg-[#fff] border border-[#d7e2ed]'} rounded-lg`}>
                            <div className="grid grid-cols-4 gap-2">
                                <div>
                                    <p>Import data for:</p>
                                    <FormControl
                                        // key={index}
                                        sx={{
                                            minWidth: "200px",
                                            width: "100%",
                                            padding: 0,
                                            margin: 0,
                                            mt: 1,
                                        }}
                                    >
                                        <Select
                                            size="small"
                                            // label={column.label}
                                            name={"importFor"}
                                            value={"Leave"}
                                        //   onChange={}
                                        //   disabled={isView}
                                        >
                                            <MenuItem value={"Leave"}>{"Leave"}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="border p-2 rounded-md my-5 flex justify-center items-center flex-col ">
                                <img
                                    src="/images/importImg.png"
                                    style={{ width: "30%", height: "30%" }}
                                />
                                <div className="text-center mt-2">
                                    {selectedFile ? (
                                        <>
                                            <p className="text-[18px]">{selectedFile.name}</p>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                sx={{ my: 2, bgcolor: '#0088FF' }}
                                            >
                                                Remove and Upload New
                                                <input type="file" hidden onChange={handleFileChange} />
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <p className="text-[18px]">Drag and drop attachment here</p>
                                            <p className="text-[14px] my-1">
                                                [only xls, xlsx, and csv formats are supported]
                                            </p>
                                            <Button
                                                variant="contained"
                                                component="label"
                                                sx={{ my: 1, bgcolor: '#0088FF' }}
                                            >
                                                Upload File
                                                <input type="file" hidden onChange={handleFileChange} />
                                            </Button>
                                            <p>Maximum upload file size is 5 MB.</p>
                                            <Button
                                                color="#0088FF"
                                                sx={{ my: 1, color: '#0088FF' }}
                                                onClick={() =>
                                                    window.open(
                                                        "../assets/files/Candidate Template.xlsx",
                                                        "_blank"
                                                    )
                                                }
                                                variant="outlined"
                                            >
                                                Download sample template
                                            </Button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </Box>
                    </div>
                )}

            </CustomImportEmpty>
        </div>
    );
};

export default ImportModal;
